import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface ImageBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

const ImageBlockRenderer: React.FC<ImageBlockRendererProps> = ({ block, config }) => {
  const s = block.settings;
  const url = typeof s.url === 'string' ? s.url : '';
  const width = typeof s.width === 'string' ? s.width : '100%';
  const alignRaw = s.align;
  const align =
    alignRaw === 'center' || alignRaw === 'right' || alignRaw === 'left'
      ? alignRaw
      : 'left';
  const caption = typeof s.caption === 'string' ? s.caption : '';

  const justify =
    align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';

  if (!url) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: justify === 'center' ? 'center' : 'stretch',
        width: '100%',
        fontFamily: config.font,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: justify,
          width: '100%',
        }}
      >
        <img
          src={url}
          alt=""
          crossOrigin="anonymous"
          style={{
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            width,
            objectFit: 'contain',
          }}
        />
      </div>
      {caption ? (
        <div
          style={{
            marginTop: 8,
            fontSize: Math.max(10, Math.round(config.fontBoyutu * 0.9)),
            color: '#555',
            textAlign: align,
            width: '100%',
          }}
        >
          {caption}
        </div>
      ) : null}
    </div>
  );
};

export default ImageBlockRenderer;
